import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { PrivateRoute, RoleBasedRoute } from './middleware/UserAccess';
import "./App.css";
import axios from "axios";
import Login from "./Auth/Login";
import NotFound from "./pages/NotFound";
import HomeClient from "./pages/client/HomeClient";
import LayoutUser from "./pages/client/Layout/LayoutUser";
import FilterData from './pages/client/FilterData';
import Chat from "./pages/client/Chat";
import ConfigDb from "./pages/admin/ConfigDb";
import Dashboard from "./pages/admin/Dashboard";
import CreateRole from "./pages/admin/roles/CreateRole";
import Layout from "./pages/admin/Layout";
import Roles from './pages/admin/roles/Roles';
import UserList from './pages/admin/users/UsersList';
import CreateUser from "./pages/admin/users/CreateUser";
import Permissions from "./pages/admin/permissions/PermissionsList";
import CreatePermission from "./pages/admin/permissions/CreatePermission";
import UpdatePermission from "./pages/admin/permissions/UpdatePermission";
import UpdateRole from "./pages/admin/roles/UpdateRole";
import UpdateUser from "./pages/admin/users/UpdateUser";
import Questions from "./pages/admin/questions/Questions";
import Timeout from "./Auth/Timeout";
import Cookies from 'js-cookie';
import { decryptData } from "./Auth/cryptage";
import DashboardSA from "./pages/superAdmin/DashboardSA";
import LayoutSA from './pages/superAdmin/Layout/LayoutSA';
import UsersListSA from "./pages/superAdmin/Users/UsersListSA";
import CreateUserSA from "./pages/superAdmin/Users/CreateUserSA";
import UpdateUserSA from "./pages/superAdmin/Users/UpdateUserSA";
import ModelsSA from "./pages/superAdmin/Questions/ModelsSA";
import QuestionsSA from "./pages/superAdmin/Questions/QuestionsSA";


function App() {
  const [isActive, setIsActive] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [canAccessChat, setCanAccessChat] = useState(() => {
    const storedCanAccessChat = Cookies.get('canAccessChat');
    return storedCanAccessChat === 'true';
  });
  const handleChatButtonClick = () => {
    setCanAccessChat(true);
    Cookies.set('canAccessChat', 'true');
  };

  const logout = async () => {
    try {
      const token = decryptData(Cookies.get('access_token'));
      await axios.post('https://api.ai.easysystem.cloud/api/logout', {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
      });
      Cookies.remove('access_token');
      Cookies.remove('role');
      Cookies.remove('user');
      Cookies.remove('resources');      
      Cookies.remove('canAccessChat');      
      window.location.href = "/";
    } catch (error) {
        console.error(error);
    }
  };

  Timeout(logout, 2 * 60 * 60 * 1000);

  const toggleSidebar = () => {
    setIsActive(!isActive);
  };

  const closeSidebar = () => {
    setIsActive(false);
  };
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <PrivateRoute>
            <Login />
          </PrivateRoute>
        } />

        {/*=================================== Client routes ================================*/}
        <Route path="/home" element={
          <RoleBasedRoute requiredRole="user">
            <LayoutUser showSidebar={false} logout={logout}>
              <HomeClient />
            </LayoutUser>
          </RoleBasedRoute>
        } />

      <Route
        path="/fillter-data/:nameR/:typeR"
        element={
          <RoleBasedRoute requiredRole="user">
            <LayoutUser showSidebar={false} logout={logout}>
              <FilterData handleChatButtonClick={handleChatButtonClick} />
            </LayoutUser>
          </RoleBasedRoute>
        }
      />
      <Route
        path="/chat"
        element={
          canAccessChat ? (
            <RoleBasedRoute requiredRole="user">
              <LayoutUser
                showSidebar={true}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={() => setSidebarOpen(!sidebarOpen)}
                logout={logout}
              >
                <Chat
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                  handleChatButtonClick={handleChatButtonClick}
                />
              </LayoutUser>
            </RoleBasedRoute>
          ) : (
            <NotFound />
          )
        }
      />
        {/* ==================================== Admin routes ================================ */}
        <Route path="/dashboard" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <Dashboard />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/db-change" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <ConfigDb />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/roles" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <Roles />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/roles/create-role" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <CreateRole />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/roles/update-role/:id" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <UpdateRole />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/users" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <UserList />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/users/create-user" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <CreateUser />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/users/update-user/:id" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <UpdateUser />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/permissions" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <Permissions />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/permissions/create-permission" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <CreatePermission />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/permissions/update-permission/:id" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <UpdatePermission />
            </Layout>
          </RoleBasedRoute>
        } />
        <Route path="/dashboard/questions" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <Questions />
            </Layout>
          </RoleBasedRoute>
        } />
        {/* <Route path="/dashboard/models" element={
          <RoleBasedRoute requiredRole="admin">
            <Layout logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <Models />
            </Layout>
          </RoleBasedRoute>
        } /> */}
        {/* ==================================== Admin routes ================================ */}
        <Route path="/superDashboard" element={
          <RoleBasedRoute requiredRole="superAdmin">
            <LayoutSA logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <DashboardSA />
            </LayoutSA>
          </RoleBasedRoute>
        } />

        <Route path="/superDashboard/users" element={
          <RoleBasedRoute requiredRole="superAdmin">
            <LayoutSA logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <UsersListSA />
            </LayoutSA>
          </RoleBasedRoute>
        } />

        <Route path="/spuerDashboard/admins/create-admin" element={
          <RoleBasedRoute requiredRole="superAdmin">
            <LayoutSA logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <CreateUserSA />
            </LayoutSA>
          </RoleBasedRoute>
        } />

        <Route path="/spuerDashboard/admins/update-admin/:id" element={
          <RoleBasedRoute requiredRole="superAdmin">
            <LayoutSA logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <UpdateUserSA />
            </LayoutSA>
          </RoleBasedRoute>
        } />
        <Route path="/spuerDashboard/models" element={
          <RoleBasedRoute requiredRole="superAdmin">
            <LayoutSA logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <ModelsSA />
            </LayoutSA>
          </RoleBasedRoute>
        } />
        <Route path="/spuerDashboard/global-questions" element={
          <RoleBasedRoute requiredRole="superAdmin">
            <LayoutSA logout={logout} isActive={isActive} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar}>
              <QuestionsSA />
            </LayoutSA>
          </RoleBasedRoute>
        } />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
